export default "__VITE_ASSET__474988fc__"